import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { GetApi, PostApi } from "../../../js_assets/Network";

import { CircularProgress, Grid, Button } from "@material-ui/core";
import AppAdminContainer from "../AppAdminContainer";
import AgGridTable from "../../agGridTable";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 8,
    margin: 12,
  },
  divider: {
    width: "100%",
  },
  ButtonSearch: {
    backgroundColor: "#007bff",
    color: "white",
    "&:hover": {
      background: "#007bff",
    },
  },
  ButtonLocation: {
    backgroundColor: "#4CAF50",
    color: "white",
    "&:hover": {
      background: "#4CAF50",
    },
  },
  ButtonGuide: {
    backgroundColor: "#74cbc4",
    color: "white",
    "&:hover": {
      background: "#74cbc4",
    },
    margin: theme.spacing.unit,
    padding: "2px",
  },
  tab: {
    flexGrow: 1,
    marginTop: 2,
    backgroundColor: "#f7faea",
  },
  iocns: {
    fontSize: 18,
  },
});

class AdminUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_data: [],
      query_reset_password: "",
      loading_state_iocn: false,
      loading_reset_password: false,
      Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
      columnDefs: [],
      rowData: [],
    };
  }




  get_all_user = () => {
    const { Admin_Info } = this.state;

    this.setState({

      loading_state_iocn: true,
    });
    Promise.all([
      GetApi(
        `/api/Admin/GetAllUser/${Admin_Info.admin_Id}`,
        Admin_Info.jwT_Token_Admin
      ),
    ]).then((rep) => {
      this.set_user_data(rep[0]);
    });
  }


  get_all_user_from_LandingPage = () => {
    const { Admin_Info } = this.state;

    this.setState({

      loading_state_iocn: true,
    });
    Promise.all([
      GetApi(
        `/api/Admin/GetAllUserFromLandingPage/${Admin_Info.admin_Id}`,
        Admin_Info.jwT_Token_Admin
      ),
    ]).then((rep) => {
      this.set_user_data(rep[0]);
    });
  }

  reset_user_password_api = () => {
    const { Admin_Info } = this.state;

    this.setState({

      loading_reset_password: true,
    });

    PostApi(
      `/api/Admin/ResetUserPassword/${Admin_Info.admin_Id}`, { query: this.state.query_reset_password },
      Admin_Info.jwT_Token_Admin
    ).then((rep) => {
      if (rep.status) {

        alert(rep.result)

      } else {

        alert("هذا غير مسجل تحقق من المدخل")
      }


      this.setState({

        loading_reset_password: false,
      });

    });
  }

  set_user_data = (user_data) => {
    let New_Set_with_split_Date = [];

    user_data.map((item) => {
      item.user_CreateDate = item.user_CreateDate.split("T")[0];

      New_Set_with_split_Date.push(item);
    });

    this.setState({
      user_data: New_Set_with_split_Date,
      loading_state_iocn: false,
    });
    this.init_columnDefs();
  };

  init_columnDefs = () => {
    const { user_data } = this.state;

    let columnDefs = [
      { headerName: "الاسم", field: "userName" },
      { headerName: "الجوال", field: "user_Phone" },
      { headerName: "الايميل", field: "user_Email" },
      { headerName: "المدينة", field: "city_Name" },
      { headerName: "تاريخ الانظمام", field: "user_CreateDate" },
    ];

    this.setState({ columnDefs: columnDefs, rowData: user_data });
  };

  render() {
    const { classes } = this.props;
    const { loading_state_iocn, columnDefs, rowData, loading_reset_password } = this.state;

    return (
      <AppAdminContainer Title={"العملاء"}>
        <div className="container">
          <div className="center" >
            <h3 className="containerOfferh4"> العملاء </h3>
          </div>
          <div className="center" >
            <span> اعاده ظبط كلمة المرور العميل</span>
          </div>

          <div className="center" >
            <input

              placeholder="ضع رقم الجوال او الايميل"
              name="number_Of_Added_Days"
              value={this.state.query_reset_password}
              onChange={e => this.setState({ query_reset_password: e.target.value })}
            />
          </div>
          <div className="center" >
            <button disabled={loading_reset_password} onClick={() => this.reset_user_password_api()}>
              {loading_reset_password ?

                <CircularProgress size={20} />
                :
                "اعادة ظبط"
              }

            </button>
          </div>

          <br />

          <div className="center" >
            <button disabled={loading_state_iocn} onClick={() => this.get_all_user()}>
              {loading_state_iocn ?

                <CircularProgress size={20} />
                :
                "جلب بيانات العملاء"
              }

            </button>



          </div>
          <br />
          <div className="center" >
            <button disabled={loading_state_iocn} onClick={() => this.get_all_user_from_LandingPage()}>
              {loading_state_iocn ?

                <CircularProgress size={20} />
                :
                "جلب بيانات العملاء صحفة الهبوط"
              }

            </button>
          </div>



          <div className="center" >
            <AgGridTable columnDefs={columnDefs} rowData={rowData} />
          </div>
        </div >
      </AppAdminContainer >
    );
  }
}
AdminUser.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminUser);
